<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-menu offset-y>
		<template v-slot:activator="{ on: menuActivator }">
			<v-list-tile-action>
				<egranty-icon-button
					icon="feedback"
					color="orange"
					:disabled="assignmentNotAllowed"
					:label="getAssignmentButtonLabel"
					for="assign-for-opinions-menu-assign-to-opinion"
					id="assign-for-opinions-menu-assign-to-opinion"
					:menu-activator="menuActivator"/>
			</v-list-tile-action>
		</template>
		<v-list>
			<v-list-tile avatar @click="openAssignForFormalEvaluationDialog(offer)"
				:disabled="assignmentForFormalEvaluationNotAllowed(offer)">
				<v-list-tile-avatar>
					<v-icon color="orange">event_seat</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-title>Przydziel do opinii formalnej</v-list-tile-title>
			</v-list-tile>
			<v-list-tile avatar @click="openAssignForSubstantiveEvaluationDialog(offer)"
				:disabled="assignmentForSubstantiveEvaluationNotAllowed(offer)">
				<v-list-tile-avatar>
					<v-icon color="orange">event_seat</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-title>Przydziel do opinii merytorycznej</v-list-tile-title>
			</v-list-tile>
			<v-list-tile avatar @click="openAssignForAgencyDialog(offer)"
				:disabled="assignmentForAgencyEvaluationNotAllowed(offer)">
				<v-list-tile-avatar>
					<v-icon color="orange">location_city</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-title>Przydziel do opinii placówki</v-list-tile-title>
			</v-list-tile>
			<v-list-tile avatar @click="openAssignForExpertDialog(offer)"
				:disabled="assignmentForExpertEvaluationNotAllowed()">
				<v-list-tile-avatar>
					<v-icon color="orange">school</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-title>Przydziel do opinii eksperta</v-list-tile-title>
			</v-list-tile>
			<v-list-tile avatar @click="openAssignForFinalEvaluationDialog(offer)"
				:disabled="assignmentForFinalEvaluationNotAllowed(offer)">
				<v-list-tile-avatar>
					<v-icon color="orange">event_seat</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-title>Przydziel do opinii końcowej</v-list-tile-title>
			</v-list-tile>
		</v-list>

		<egranty-input-field-popup
			:is-open.sync="dialogsState.assignForFormalEvaluation.open"
			:select-items="dialogsState.assignForFormalEvaluation.committeeUsers"
			:validation-rules="[formalEvaluatorsValidationRule]"
			label="Członkowie komisji do oceny"
			for="assign-for-opinions-menu-committee-users"
			id="assign-for-opinions-menu-committee-users"
			title="Przekazanie oferty do opinii formalnej"
			field-type="SELECT_MANY"
			@save="assignSelectedOfferForFormalEvaluation"
			:loading="loading">
		</egranty-input-field-popup>

		<egranty-input-field-popup
			:is-open.sync="dialogsState.assignForSubstantiveEvaluation.open"
			:select-items="dialogsState.assignForSubstantiveEvaluation.committeeUsers"
			:validation-rules="[substantiveEvaluatorsValidationRule]"
			label="Członkowie komisji do opinii"
			for="assign-for-opinions-menu-committee-users-to-substantive-opinion-"
			id="assign-for-opinions-menu-committee-users-to-substantive-opinion"
			title="Przekazanie oferty do opinii merytorycznej"
			field-type="SELECT_MANY"
			@save="assignSelectedOfferForSubstantiveEvaluation"
			:loading="loading">
		</egranty-input-field-popup>

		<egranty-input-field-popup
			:is-open.sync="dialogsState.assignForFinalEvaluation.open"
			:select-items="dialogsState.assignForFinalEvaluation.committeeUsers"
			label="Członkowie komisji do opinii"
			for="assign-for-opinions-menu-committee-users-to-final-opinion-"
			id="assign-for-opinions-menu-committee-users-to-final-opinion"
			title="Przekazanie oferty do opinii końcowej"
			field-type="SELECT"
			@save="assignSelectedOfferForFinalEvaluation"
			:loading="loading">
		</egranty-input-field-popup>

		<egranty-input-field-popup
			:is-open.sync="dialogsState.assignForAgency.open"
			:select-items="dialogsState.assignForAgency.agencies"
			label="Nazwa placówki"
			for="assign-for-opinions-menu-name-agency"
			id="assign-for-opinions-menu-name-agency"
			title="Przydzielenie oferty do placówki"
			field-type="SELECT"
			@save="assignSelectedOfferForAgency"
			:loading="loading">
		</egranty-input-field-popup>

		<egranty-input-field-popup
			:is-open.sync="dialogsState.assignForExpert.open"
			:select-items="dialogsState.assignForExpert.experts"
			label="Eksperci do opiniowania"
			for="assign-for-opinions-menu-committee-expert-to-opinion-"
			id="assign-for-opinions-menu-committee-expert-to-opinion"
			title="Przekazanie oferty do opinii ekspertów"
			field-type="SELECT_MANY"
			@save="assignSelectedOfferForExpert"
			:loading="loading">
		</egranty-input-field-popup>
	</v-menu>
</template>
<script>
	import {CommitteeUsers} from "../../../../api/generated/CommitteeUsers";
	import {PublicContest} from "../../../../api/generated/PublicContest";
	import {FormalEvaluation} from "../../../../api/generated/FormalEvaluation";
	import {SubstantiveEvaluation} from "../../../../api/generated/SubstantiveEvaluation";
	import {AgencyEvaluation} from "../../../../api/generated/AgencyEvaluation";
	import {FinalEvaluation} from "../../../../api/generated/FinalEvaluation";
	import {ExpertEvaluation} from "../../../../api/generated/ExpertEvaluation";
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";
	import EgrantyIconButton from "../../../../genericComponents/EgrantyIconButton";

	export default {
		name: "assign-for-opinions-menu",
		components: {EgrantyIconButton, EgrantyInputFieldPopup},

		data () {
			return {
				dialogsState: {
					assignForFormalEvaluation: {
						open: false,
						committeeUsers: [],
					},
					assignForSubstantiveEvaluation: {
						open: false,
						committeeUsers: [],
					},
					assignForFinalEvaluation: {
						open: false,
						committeeUsers: [],
					},
					assignForAgency: {
						open: false,
						agencies: [],
					},
					assignForExpert: {
						open: false,
						experts: [],
					},
					selectedOffer: null,
				},
				loading:false
			};
		},

		computed: {
			assignmentNotAllowed () {
				return this.contestEvaluationNotAllowed ||
					this.offerEvaluationNotAllowed ||
					this.committeeNotAssigned ||
					this.noAccess;
			},

			getAssignmentButtonLabel () {
				if (this.noAccess) {
					return 'Przydziel do opinii / oceny';
				} else if (this.contestEvaluationNotAllowed) {
					return 'Przydziel do opinii / oceny (nieodpowiedni status konkursu)';
				} else if (this.offerEvaluationNotAllowed) {
					return 'Przydziel do opinii / oceny (nieodpowiedni status oferty)';
				} else if (this.committeeNotAssigned) {
					return 'Przydziel do opinii / oceny (brak przypisania do komisji)';
				} else {
					return 'Przydziel do opinii / oceny';
				}
			}
		},

		methods: {
			openAssignForFormalEvaluationDialog (offer) {
				if (this.assignmentForFormalEvaluationNotAllowed(offer)) return;
				this.dialogsState.selectedOffer = offer;
				CommitteeUsers.getCommitteeUsersAvailable(this, offer.committeeId,
					successResponse => {
						this.dialogsState.assignForFormalEvaluation.committeeUsers = successResponse
							.filter(cu => !offer.formalEvaluations.some(e => e.committeeUser.id === cu.id));
						this.dialogsState.assignForFormalEvaluation.open = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy członków komisji", errorResponse);
					});
			},

			openAssignForSubstantiveEvaluationDialog (offer) {
				if (this.assignmentForSubstantiveEvaluationNotAllowed(offer)) return;
				this.dialogsState.selectedOffer = offer;
				CommitteeUsers.getCommitteeUsersAvailable(this, offer.committeeId,
					successResponse => {
						this.dialogsState.assignForSubstantiveEvaluation.committeeUsers = successResponse
							.filter(cu => !offer.substantiveEvaluations.some(e => e.committeeUser.id === cu.id));
						this.dialogsState.assignForSubstantiveEvaluation.open = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy członków komisji", errorResponse);
					});
			},

			openAssignForFinalEvaluationDialog (offer) {
				if (this.assignmentForFinalEvaluationNotAllowed(offer)) return;
				this.dialogsState.selectedOffer = offer;
				CommitteeUsers.getCommitteeUsersAvailable(this, offer.committeeId,
					successResponse => {
						this.dialogsState.assignForFinalEvaluation.committeeUsers = offer.finalEvaluation !== null ?
							successResponse.filter(user => user.id !== offer.finalEvaluation.committeeUser.id) :
							successResponse;
						this.dialogsState.assignForFinalEvaluation.open = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy członków komisji", errorResponse);
					});
			},

			openAssignForAgencyDialog (offer) {
				if (this.assignmentForAgencyEvaluationNotAllowed(offer)) return;
				this.dialogsState.selectedOffer = offer;
				AgencyEvaluation.getAvailableAgencies(this, this.dialogsState.selectedOffer.id,
					successResponse => {
						this.dialogsState.assignForAgency.agencies = offer.agencyEvaluation !== null ?
							successResponse.filter(a => offer.agencyEvaluation.agency.id !== a.id) :
							successResponse;
						this.dialogsState.assignForAgency.open = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy placówek", errorResponse);
					});
			},

			openAssignForExpertDialog (offer) {
				if (this.assignmentForExpertEvaluationNotAllowed(offer)) return;
				this.dialogsState.selectedOffer = offer;
				PublicContest.getExperts(this, this.contestId,
					successResponse => {
						this.dialogsState.assignForExpert.experts = successResponse
							.filter(cu => !offer.expertEvaluations.some(e => e.contestUser.id === cu.id));
						this.dialogsState.assignForExpert.open = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy ekspertów", errorResponse);
					});
			},

			assignSelectedOfferForFormalEvaluation (committeeUsersIds) {
				if(!this.loading){
				this.loading = true;
				FormalEvaluation.postCommitteeUsers(this, this.dialogsState.selectedOffer.id, committeeUsersIds,
					successResponse => {
						this.dialogsState.assignForFormalEvaluation.open = false;
						this.$emit("evaluation-assigned");
						this.$messagesBus.$emit("success", "Pomyślnie przypisano oceniających", successResponse);
						this.loading = false;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się przypisać oceniających", errorResponse);
						this.loading = false;
					});
				}
			},

			assignSelectedOfferForSubstantiveEvaluation (committeeUsersIds) {
				if(!this.loading){
				this.loading = true;
				SubstantiveEvaluation.postCommitteeUsers(this, this.dialogsState.selectedOffer.id, committeeUsersIds,
					successResponse => {
						this.dialogsState.assignForSubstantiveEvaluation.open = false;
						this.$emit("evaluation-assigned");
						this.$messagesBus.$emit("success", "Pomyślnie przypisano oceniających", successResponse);
						this.loading = false;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się przypisać oceniających", errorResponse);
						this.loading = false;
					});
				}
			},

			assignSelectedOfferForFinalEvaluation (committeeUserId) {
				if(!this.loading){
				this.loading = true;
				FinalEvaluation.postCommitteeUser(this, this.dialogsState.selectedOffer.id, committeeUserId,
					successResponse => {
						this.dialogsState.assignForFinalEvaluation.open = false;
						this.$emit("evaluation-assigned");
						this.$messagesBus.$emit("success", "Pomyślnie przypisano oceniającego", successResponse);
						this.loading = false;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się przypisać oceniającego", errorResponse);
						this.loading = false;
					});
				}
			},

			assignSelectedOfferForAgency (agencyId) {
				if(!this.loading){
				this.loading = true;
				AgencyEvaluation.post(this, this.dialogsState.selectedOffer.id, agencyId,
					successResponse => {
						this.dialogsState.assignForAgency.open = false;
						this.$emit("evaluation-assigned");
						this.$messagesBus.$emit("success", "Pomyślnie przypisano placówkę", successResponse);
						this.loading = false;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się przypisać placówki", errorResponse);
						this.loading = false;
					});
				}
			},

			assignSelectedOfferForExpert (expertIds) {
				if(!this.loading){
				this.loading = true;
				ExpertEvaluation.postContestUsers(this, this.dialogsState.selectedOffer.id, expertIds,
					successResponse => {
						this.dialogsState.assignForExpert.open = false;
						this.$emit("evaluation-assigned");
						this.$messagesBus.$emit("success", "Pomyślnie przypisano ekspertów", successResponse);
						this.loading = false;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się przypisać ekspertów", errorResponse);
						this.loading = false;
					});
				}
			},

			assignmentForFormalEvaluationNotAllowed (offer) {
				return !offer.committeeId ||
					!this.inclusionStatuses.formalEvaluationSchemaIncluded ||
					offer.formalEvaluations.length === 2;
			},

			assignmentForSubstantiveEvaluationNotAllowed (offer) {
				return !offer.committeeId ||
					!this.inclusionStatuses.individualEvaluationSchemaIncluded ||
					offer.substantiveEvaluations.length === 3;
			},

			assignmentForFinalEvaluationNotAllowed (offer) {
				return !offer.committeeId ||
					offer.finalEvaluation !== null ||
					!this.inclusionStatuses.finalEvaluationSchemaIncluded;
			},

			assignmentForAgencyEvaluationNotAllowed (offer) {
				return offer.agencyEvaluation !== null ||
					!this.inclusionStatuses.agencyEvaluationSchemaIncluded;
			},

			assignmentForExpertEvaluationNotAllowed () {
				return !this.inclusionStatuses.expertEvaluationSchemaIncluded;
			},

			formalEvaluatorsValidationRule (values) {
				let currentSize = this.offer.formalEvaluations.length;
				if (values.length + currentSize > 2) {
					return "W ocenie może brać udział co najwyżej 2 oceniających";
				} else {
					return true;
				}
			},

			substantiveEvaluatorsValidationRule (values) {
				let currentSize = this.offer.substantiveEvaluations.length;
				if (values.length + currentSize > 3) {
					return "W ocenie może brać udział co najwyżej 3 oceniających";
				} else {
					return true;
				}
			},
		},

		props: {
			offer: {
				type: Object, default: () => {
				}
			},
			contestId: {type: String},
			contestEvaluationNotAllowed: {type: Boolean, default: false},
			offerEvaluationNotAllowed: {type: Boolean, default: false},
			committeeNotAssigned: {type: Boolean, default: false},
			noAccess: {type: Boolean, default: false},
			inclusionStatuses: {
				type: Object, default: () => {
					return {
						agencyEvaluationSchemaIncluded: false,
						expertEvaluationSchemaIncluded: false,
						finalEvaluationSchemaIncluded: false,
						formalEvaluationSchemaIncluded: false,
						individualEvaluationSchemaIncluded: false
					};
				}
			}
		},
	};
</script>
